<template>
  <div class="img-overlay-card" :class="classObject">
    <div class="img-wrap">
      <img
        :src="generateImageUrl(item.image)"
        alt="Complete profile"
        @click="index = 1"
      />
    </div>
    <div class="text-content">
      <div class="place-title">{{ item.title }}</div>
      <div class="place-caption">{{ item.caption }}</div>
      <div class="button-wrap">
        <div
          class="custom-button"
          v-for="(button, index) in item.button"
          :key="index"
        >
          <router-link target="_blank" :to="`/${button.link}`">
            {{ button.text }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    item: {
      type: Object
    },
    extraClass: {
      type: [String, Array]
    }
  },
  data() {
    return {
      index: null
    };
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.img-overlay-card {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(180, 38, 45, 0.4);
    @include customTransition(0.2s, cubic-bezier(0.44, 0.9, 1, 1));
  }
  .img-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .text-content {
    position: relative;
    z-index: 2;
    padding: 80px 50px;
    color: #ffffff;
    text-align: center;
    .place-title {
      text-transform: uppercase;
      font-family: $heading-font;
      font-size: 32px;
      letter-spacing: 1.8px;
      margin-bottom: 15px;
    }
    .place-caption {
      font-family: $content-font;
      font-size: 14px;
    }
    .button-wrap {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      .custom-button {
        margin-right: 10px;
        a {
          text-transform: uppercase;
          color: #212164;
          font-size: 12px;
          font-weight: 700;
          background: #ffffff;
          border-color: #ffffff;
          &:hover {
            border-color: #ffffff;
            background: transparent;
            color: #ffffff;
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  &:hover {
    &::before {
      background: rgba(180, 38, 45, 0.87);
    }
  }
  &.blue-bg {
    &::before {
      background: rgba(33, 33, 100, 0.4);
    }
    &:hover {
      &::before {
        background: rgba(33, 33, 100, 0.87);
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .img-overlay-card {
    .text-content {
      padding: 80px 30px;
      .button-wrap {
        flex-direction: column;
        .custom-button {
          margin: 0 0 30px 0;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .img-overlay-card {
    .text-content {
      padding: 60px 20px;
      .place-title {
        font-size: 26px;
        line-height: 34px;
      }
      .place-caption {
        font-size: 12px;
      }
      .button-wrap {
        .custom-button {
          margin-bottom: 20px;
          a {
            font-size: 10px;
            padding: 6px 30px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .img-overlay-card {
    .text-content {
      padding: 40px 20px;
      .place-title {
        font-size: 22px;
        line-height: 30px;
      }
      .place-caption {
        font-size: 12px;
      }
      .button-wrap {
        .custom-button {
          margin-bottom: 15px;
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .img-overlay-card {
    .text-content {
      .place-title {
        font-size: 28px;
        line-height: 36px;
      }
      .place-caption {
        font-size: 14px;
      }
      .button-wrap {
        .custom-button {
          margin-bottom: 30px;
          a {
            font-size: 12px;
            padding: 10px 30px;
          }
        }
      }
    }
  }
}
</style>
